import { Card, CardContent, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

export const DashboardCard = ({ title, amount, description, icon, color }: any) => (
	<Card
		sx={{
			height: '100%',
			background: `linear-gradient(135deg, ${color} 0%, ${color}80 100%)`,
			color: 'white',
			borderRadius: '12px',
			boxShadow: '0 4px 20px 0 rgba(0,0,0,0.12)',
			transition: 'transform 0.3s ease-in-out',
			'&:hover': {
				transform: 'translateY(-5px)',
			},
		}}
	>
		<CardContent sx={{ p: 3 }}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
				<Box>
					<Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
						{title}
					</Typography>
					<Typography variant="h4" fontWeight="bold">
						{amount}
					</Typography>
				</Box>
				<Box
					sx={{
						width: 48,
						height: 48,
						borderRadius: '12px',
						backgroundColor: 'rgba(255,255,255,0.2)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					{icon}
				</Box>
			</Stack>
			<Typography variant="caption" sx={{ opacity: 0.8 }}>
				{description}
			</Typography>
		</CardContent>
	</Card>
);
